export default __webpack_public_path__ + "static/media/coverity.21699d69.svg";